import { render } from "./WalkThrough.vue?vue&type=template&id=d5284b70&scoped=true"
import script from "./WalkThrough.vue?vue&type=script&lang=js"
export * from "./WalkThrough.vue?vue&type=script&lang=js"

import "./WalkThrough.vue?vue&type=style&index=0&id=d5284b70&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5284b70"]])

export default __exports__